import { useEffect, useState } from "react";
import { post_CourseCategory } from "../services/Course";
import useAuth from "../hook/useAuth";
import { PleasewaitPopup } from "./PleasewaitPopup";

type AddCourseCategoryProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshCourseCategory: (value: boolean) => void;
}

export const AddCourseCategory = ({ showPopup, setShowPopup, setRefreshCourseCategory }: AddCourseCategoryProps) => {
    const { auth }: any = useAuth();
    const [categoryName, setCategoryName] = useState<string>("");
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);


    if (!showPopup) return null;

    const handleOnSave = () => {
        setShowPleasewait(true)
        post_CourseCategory({
            name: categoryName,
            orderNumber: 0,
            createdAt: new Date().toLocaleString(),
            createdBy: auth?.givenname
        }, auth?.id)
            .then((res) => {
                setShowPleasewait(false);
                setShowPopup(false);
                setRefreshCourseCategory(true);
            })
            .catch((error) => {
                console.error(error);
            })

    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-3xl rounded-md shadow-lg max-h-[90vh] flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add category</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>

                    <div className="p-6">

                        <label className="font-medium">Category Name</label>
                        <input
                            type="text"
                            placeholder="e.g., Mr. David math class"
                            className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                        />
                    </div>



                    {/* Footer */}
                    <div className="px-6 py-4 border-t flex justify-end space-x-3">


                        <button
                            className={`px-6 py-2 ${!categoryName ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={!categoryName ? true : false}
                            onClick={handleOnSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div >

            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}